import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useMemo, useRef } from "react"
import { useCreateZAP } from "../../../../../components/WMS/ProcurementRequests/useCreateZAP"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"

type Search = {
  warehouseId?: string
  items?: string
}

type RawSearch = {
  warehouseId?: unknown
  items?: unknown
}

type PrefillItem = {
  product_id: string
  requested_qty?: number | string
  comment?: string
}

export const Route = createFileRoute("/_layout/WMS/documents/zap/new")({
  component: CreateZapDraftPage,
  validateSearch: (search: RawSearch): Search => ({
    warehouseId:
      typeof search.warehouseId === "string" ? search.warehouseId : undefined,
    items: typeof search.items === "string" ? search.items : undefined,
  }),
})

function CreateZapDraftPage() {
  const navigate = useNavigate()
  const { warehouseId, items: rawItems } = Route.useSearch()
  const { createZAP, isCreating, isResolvingWarehouses, canCreate } =
    useCreateZAP()
  const startedRef = useRef(false)

  const prefilledItems = useMemo<PrefillItem[] | undefined>(() => {
    if (!rawItems) return undefined
    try {
      const parsed = JSON.parse(rawItems)
      return Array.isArray(parsed) ? parsed : undefined
    } catch {
      return undefined
    }
  }, [rawItems])

  useEffect(() => {
    if (startedRef.current || isResolvingWarehouses) return
    if (!canCreate) return
    startedRef.current = true
    void createZAP(warehouseId, prefilledItems)
  }, [canCreate, createZAP, isResolvingWarehouses, prefilledItems, warehouseId])

  const handleCancel = () => {
    if (warehouseId) {
      navigate({
        to: "/WMS/warehouses/$warehouse",
        params: { warehouse: warehouseId },
      })
      return
    }
    navigate({
      to: "/WMS/documents/document-list",
      search: { page: 1, page_size: 50 },
    })
  }

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument ZAP"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu ZAP..."
      idleLabel="Przygotowywanie edycji dokumentu ZAP..."
    />
  )
}
